export default "__VITE_ASSET__febf46b0__"